
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.682 22c-2.454 0-4.826-.887-6.679-2.497A10.19 10.19 0 019.871 2.022a.522.522 0 01.532.145.532.532 0 01.136.523 9.113 9.113 0 004.68 10.684 9.095 9.095 0 006.603.597.535.535 0 01.659.66A10.227 10.227 0 0112.682 22z","fill":"#00AEEF"}}),_c('path',{attrs:{"d":"M20.068 9.957c-.2.72-.516.72-.716 0a2.626 2.626 0 00-1.647-1.665c-.72-.195-.72-.516 0-.711a2.616 2.616 0 001.661-1.661c.2-.72.516-.72.715 0a2.615 2.615 0 001.661 1.66c.72.196.72.517 0 .712a2.625 2.625 0 00-1.674 1.665zM16.31 2.674c-.113.421-.298.421-.411 0a1.542 1.542 0 00-.974-.973c-.42-.113-.42-.303 0-.417a1.544 1.544 0 00.97-.968c.112-.421.298-.421.411 0a1.543 1.543 0 00.973.968c.421.114.421.304 0 .417a1.544 1.544 0 00-.968.973z","fill":"#FDB728"}})])
          )
        }
      }
    